import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Spinner, Pagination, Button } from 'react-bootstrap';
import { FaFilter, FaBoxOpen, FaTh, FaList } from 'react-icons/fa';
import ProductCard from '../components/ProductCard';
import useProductsStore from '../store/productsStore';
import { useSearchParams } from 'react-router-dom';
import './Products.css';

const Products = () => {
  const { products, categories, pagination, isLoading, fetchProducts, fetchCategories } = useProductsStore();
  const [searchParams, setSearchParams] = useSearchParams();
  
  const [filters, setFilters] = useState({
    search: searchParams.get('search') || '',
    category: searchParams.get('category') || '',
    sort: searchParams.get('sort') || '',
    page: parseInt(searchParams.get('page')) || 1,
  });

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  useEffect(() => {
    const params = {
      ...filters,
    };
    fetchProducts(params);
    setSearchParams(params);
  }, [filters, fetchProducts, setSearchParams]);

  const handleFilterChange = (name, value) => {
    setFilters(prev => ({ ...prev, [name]: value, page: 1 }));
  };

  const handlePageChange = (page) => {
    setFilters(prev => ({ ...prev, page }));
  };

  return (
    <div className="products-page">
      {/* Header */}
      <div className="products-header">
        <Container>
          <div className="products-header-content">
            <h1>Browse Our Products</h1>
            <p>Find the perfect software solution for your needs</p>
            {pagination.total > 0 && (
              <div className="products-count">
                <FaBoxOpen className="me-2" />
                {pagination.total} Products Available
              </div>
            )}
          </div>
        </Container>
      </div>

      <Container>
        <Row>
          {/* Filters Sidebar */}
          <Col lg={3} md={4} className="mb-4">
            <div className="filters-card">
              <h5>
                <FaFilter /> Filters
              </h5>
              
              {/* Search */}
              <div className="filter-group">
                <label>Search</label>
                <Form.Control
                  type="text"
                  placeholder="Search products..."
                  value={filters.search}
                  onChange={(e) => handleFilterChange('search', e.target.value)}
                  className="filter-input"
                />
              </div>

              {/* Category */}
              <div className="filter-group">
                <label>Category</label>
                <Form.Select
                  value={filters.category}
                  onChange={(e) => handleFilterChange('category', e.target.value)}
                  className="filter-select"
                >
                  <option value="">All Categories</option>
                  {categories.map((cat) => (
                    <option key={cat} value={cat}>{cat}</option>
                  ))}
                </Form.Select>
              </div>

              {/* Sort */}
              <div className="filter-group">
                <label>Sort By</label>
                <Form.Select
                  value={filters.sort}
                  onChange={(e) => handleFilterChange('sort', e.target.value)}
                  className="filter-select"
                >
                  <option value="">Latest</option>
                  <option value="price-low">Price: Low to High</option>
                  <option value="price-high">Price: High to Low</option>
                  <option value="popular">Most Popular</option>
                </Form.Select>
              </div>
            </div>
          </Col>

          {/* Products Grid */}
          <Col lg={9} md={8}>
            {isLoading ? (
              <div className="products-loading">
                <div className="loading-spinner-custom"></div>
                <p className="loading-text">Loading products...</p>
              </div>
            ) : (
              <div className="products-grid-container">
                {products.length > 0 ? (
                  <>
                    <div className="products-grid">
                      {products.map((product) => (
                        <ProductCard key={product._id} product={product} />
                      ))}
                    </div>

                    {/* Pagination */}
                    {pagination.pages > 1 && (
                      <div className="pagination-container">
                        <div className="modern-pagination">
                          <Pagination>
                    <Pagination.First 
                      onClick={() => handlePageChange(1)}
                      disabled={pagination.page === 1}
                    />
                    <Pagination.Prev 
                      onClick={() => handlePageChange(pagination.page - 1)}
                      disabled={pagination.page === 1}
                    />
                    
                    {[...Array(pagination.pages)].map((_, i) => (
                      <Pagination.Item
                        key={i + 1}
                        active={i + 1 === pagination.page}
                        onClick={() => handlePageChange(i + 1)}
                      >
                        {i + 1}
                      </Pagination.Item>
                    ))}
                    
                    <Pagination.Next 
                      onClick={() => handlePageChange(pagination.page + 1)}
                      disabled={pagination.page === pagination.pages}
                    />
                            <Pagination.Last 
                              onClick={() => handlePageChange(pagination.pages)}
                              disabled={pagination.page === pagination.pages}
                            />
                          </Pagination>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="no-products">
                    <FaBoxOpen className="no-products-icon" />
                    <h3>No Products Found</h3>
                    <p>We couldn't find any products matching your search criteria.</p>
                    <Button 
                      variant="primary" 
                      onClick={() => setFilters({ search: '', category: '', sort: '', page: 1 })}
                      className="btn-modern"
                    >
                      Clear Filters
                    </Button>
                  </div>
                )}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Products;
